import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Content4({ data }) {
    const { content4ButtonEmailLink, content4ButtonText, content4ButtonType, content4ButtonPageLink, content4Title, content4Text, content4Image, content4ButtonExternalLink } = data
    return (
        <div className='image-radius-pattern-2 img-r-rt-img-col light-grey-bg'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                        <div className='image-l-patrn-2 img-blue-bg'>
                            <GatsbyImage
                                image={getImage(content4Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                    <div className='col-md-7'>
                        <div className='image-l-patten-content careers-s1-rt-content'>
                            <h2 className='heading-level-2 blue-color'>{content4Title && parser(content4Title)}</h2>
                            <p>{content4Text && parser(content4Text)}</p>
                            {content4ButtonType == 'internal' && (
                                content4ButtonPageLink && (
                                    <Link to={content4ButtonPageLink.uri} className='btn blue-btn'>
                                        {content4ButtonText}
                                    </Link>
                                )
                            ) || content4ButtonType == 'email' && (
                                <a href={`mailto: ${content4ButtonEmailLink}`} className='btn blue-btn'>
                                    {content4ButtonText}
                                </a>
                            )|| content4ButtonExternalLink == 'external' && (
                                <a href={content4ButtonExternalLink} className="btn blue-btn">
                                    {content4ButtonText}
                                </a>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
